import * as React from 'react';
import * as styles from './styles.css';

export interface IChartLayoutProps {
  children: React.ReactNode | React.ReactNode[];
}

export function ChartLayout({ children }: IChartLayoutProps) {
  return <div className={styles['container']}>{children}</div>;
}
